import { render, staticRenderFns } from "./impacted-person-supports.vue?vue&type=template&id=6625e75a&scoped=true"
import script from "./impacted-person-supports.vue?vue&type=script&lang=js"
export * from "./impacted-person-supports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6625e75a",
  null
  
)

export default component.exports